"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line import/prefer-default-export
var Typename;
(function (Typename) {
    Typename["VodPlayback"] = "VodPlaybackSources";
    Typename["LinearPlayback"] = "LinearPlaybackSources";
    Typename["ConcurrencyError"] = "ConcurrentStreamsExceeded";
    Typename["SubscriptionNeeded"] = "SubscriptionNeeded";
    Typename["PinValidationResult"] = "PinValidationResult";
    Typename["PinValidationFailure"] = "PinValidationFailure";
    Typename["TvodPurchaseExpired"] = "TvodPurchaseExpired";
    Typename["TvodPurchaseMissing"] = "TvodPurchaseMissing";
})(Typename = exports.Typename || (exports.Typename = {}));
//# sourceMappingURL=Typename.js.map